import React from 'react';
import ReactDOM from 'react-dom';
import './ContextMenu.css';

const ContextMenu = ({ 
  visible, 
  position, 
  onClose, 
  selectedFiles, 
  onCopy, 
  onPaste, 
  onDelete, 
  onRename, 
  onDownload,
  onCut,
  onSelectAll,
  onRefresh,
  canPaste = false,
  canRename = false,
  canDelete = false,
  canDownload = false,
  onRightClickOnBackdrop = null // Callback when right-clicking on backdrop
}) => {
  if (!visible) return null;

  const handleAction = (action) => {
    action();
    onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleBackdropContextMenu = (e) => {
    // Prevent browser context menu when right-clicking on backdrop
    e.preventDefault();
    e.stopPropagation();
    
    // Close current menu and notify parent to open new one at this position
    // The parent will handle opening at the new click position
    if (onRightClickOnBackdrop) {
      onRightClickOnBackdrop(e);
    } else {
      onClose();
    }
  };

  // Debug positioning
  console.log('Context menu position:', position);

  const menu = (
    <div 
      className="context-menu-backdrop" 
      onClick={handleBackdropClick}
      onContextMenu={handleBackdropContextMenu}
    >
      <div 
        className="context-menu"
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`
        }}
        onClick={(e) => e.stopPropagation()}
        onContextMenu={(e) => {
          // Prevent context menu on the menu itself
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <div className="context-menu-item" onClick={() => handleAction(onCopy)}>
          <i className="fas fa-copy"></i>
          <span>Copy</span>
          <span className="shortcut">Ctrl+C</span>
        </div>
        
        <div className="context-menu-item" onClick={() => handleAction(onCut)}>
          <i className="fas fa-cut"></i>
          <span>Cut</span>
          <span className="shortcut">Ctrl+X</span>
        </div>
        
        <div 
          className={`context-menu-item ${!canPaste ? 'disabled' : ''}`} 
          onClick={() => canPaste && handleAction(onPaste)}
        >
          <i className="fas fa-paste"></i>
          <span>Paste</span>
          <span className="shortcut">Ctrl+V</span>
        </div>
        
        <div className="context-menu-separator"></div>
        
        <div 
          className={`context-menu-item ${!canRename ? 'disabled' : ''}`} 
          onClick={() => canRename && handleAction(onRename)}
        >
          <i className="fas fa-edit"></i>
          <span>Rename</span>
          <span className="shortcut">F2</span>
        </div>
        
        <div 
          className={`context-menu-item ${!canDelete ? 'disabled' : ''}`} 
          onClick={() => canDelete && handleAction(onDelete)}
        >
          <i className="fas fa-trash"></i>
          <span>Delete</span>
          <span className="shortcut">Del</span>
        </div>
        
        <div className="context-menu-separator"></div>
        
        <div 
          className={`context-menu-item ${!canDownload ? 'disabled' : ''}`} 
          onClick={() => canDownload && handleAction(onDownload)}
        >
          <i className="fas fa-download"></i>
          <span>Download</span>
        </div>
        
        <div className="context-menu-separator"></div>
        
        <div className="context-menu-item" onClick={() => handleAction(onSelectAll)}>
          <i className="fas fa-check-square"></i>
          <span>Select All</span>
          <span className="shortcut">Ctrl+A</span>
        </div>
        
        <div className="context-menu-item" onClick={() => handleAction(onRefresh)}>
          <i className="fas fa-sync-alt"></i>
          <span>Refresh</span>
          <span className="shortcut">F5</span>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(menu, document.body);
};

export default ContextMenu;
